import React from 'react';
import { X } from 'lucide-react';
import protegaLogo from '@/assets/ProtegaHighRes.png';

interface ScanQRHeaderProps {
    merchantName?: string;
    merchantLogo?: string;
    onClose: () => void;
}

const ScanQRHeader: React.FC<ScanQRHeaderProps> = ({ merchantName = "Merchant", merchantLogo, onClose }) => {
    // Split merchant name for stacking if needed, or just hardcode the specific styling for this merchant
    // For now, mirroring the exact structure we built in ScanQRPage

    return (
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-8">
            <div className="tw-flex-1 tw-flex tw-justify-center">
                <img src={protegaLogo} alt="Protega" className="tw-h-10 sm:tw-h-14 tw-w-auto tw-object-contain" />
            </div>

            <div className="tw-flex-shrink-0 tw-px-4">
                <button onClick={onClose} className="tw-p-2 tw-hover:tw-bg-gray-100 tw-rounded-full tw-transition-colors">
                    <X className="tw-w-8 tw-h-8 sm:tw-w-10 sm:tw-h-10 tw-text-black" strokeWidth={1.5} />
                </button>
            </div>

            {/* Merchant Brand */}
            <div className="tw-flex-1 tw-flex tw-justify-center">
                {merchantLogo ? (
                    <img
                        src={merchantLogo}
                        alt={merchantName}
                        className="tw-h-10 sm:tw-h-14 tw-w-auto tw-object-contain"
                    />
                ) : (
                    <div className="tw-flex tw-items-center tw-bg-gray-100 tw-px-4 tw-py-2 tw-rounded-md tw-h-14">
                        <h1 className="tw-text-xl sm:tw-text-lg tw-font-bold tw-tracking-tight tw-uppercase tw-text-gray-900">
                            {merchantName}
                        </h1>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ScanQRHeader;
